import type { EpisodeCategory } from '../../../../../common/enums/episodeCategory';
import type { IAuthorization } from '../../../../../common/interfaces/request';
import type { IRequestsFindFilter } from '../../../interfaces/requestsFindFilter';
import type { ISearchFilter } from '../requestsList/RequestsListHeader';
import type { IGroupedWorklistUrlParams } from './buildGroupedWorklistUrl';
import { WorkListFilter } from '../../../../../common/enums/workListFilter';
import { UrlBuilder } from '../../../../../common/utils/urlBuilder';
import { addSearchFilters } from './buildGroupedWorklistUrl';

export function buildWorklistUrl(
    searchFilter: ISearchFilter,
    workListFilter: WorkListFilter | undefined,
    filter: IRequestsFindFilter,
    page: number = 1,
    limit: number = 20,
    authorization?: IAuthorization,
    selectedEpisodeCategory?: EpisodeCategory,
    excludeEpisodeCategory?: boolean,
    year?: number | null,
    month?: number | null,
    sortBy?: string,
    sortDirection?: 'ASC' | 'DESC'
) {
    const urlBuilder = new UrlBuilder<IWorklistUrlParams>('/api/requests/worklist');

    urlBuilder.add('page', page);
    urlBuilder.add('limit', limit);

    if (sortBy) {
        urlBuilder.add('sortBy', sortBy);
    }

    if (sortDirection) {
        urlBuilder.add('sortDirection', sortDirection);
    }

    addSearchFilters(searchFilter, filter, urlBuilder);

    if (authorization && authorization.canSeeRequesterAndCareProviderContext) {
        urlBuilder.add('includeItemAuthorizations', 'canSeeRequesterAndCareProviderContext');
    }
    if (selectedEpisodeCategory) {
        if (excludeEpisodeCategory) {
            urlBuilder.add('excludeEpisodeCategory', selectedEpisodeCategory);
        } else {
            urlBuilder.add('episodeCategory', selectedEpisodeCategory);
        }
    }

    if (workListFilter) {
        urlBuilder.add('workListFilter', workListFilter);
    }

    if (workListFilter === WorkListFilter.closedRequests) {
        if (year) {
            urlBuilder.add('year', year);
        }
        if (month !== null && month !== undefined) {
            urlBuilder.add('month', month + 1);
        }
    }

    return urlBuilder.build();
}

interface IWorklistUrlParams extends IGroupedWorklistUrlParams {
    episodeCategory?: EpisodeCategory;
    excludeEpisodeCategory?: EpisodeCategory;
    includeItemAuthorizations?: string;
    limit: number;
    month?: number;
    page: number;
    sortBy?: string;
    sortDirection?: 'ASC' | 'DESC';
    workListFilter: WorkListFilter;
    year?: number;
}
